import InputAdornment from '@mui/material/InputAdornment';
import moment from 'moment';
import isEmail from 'validator/lib/isEmail';
import isFloat from 'validator/lib/isFloat';
import isInt from 'validator/lib/isInt';
import isURL from 'validator/lib/isURL';
import isUUID from 'validator/lib/isUUID';

export const validationRules = {
  required: 'This field is required',
  maxLength255: {
    value: 255,
    message: 'Must not exceed 255 characters',
  },
  email: (value) => !value || isEmail(value) || 'This field must be a valid e-mail',
  url: (value) => !value || isURL(value, { require_protocol: true }) || 'This field must be a valid URL',
  boolean: (value) => value === true || value === false || value === null || 'This field must be a Boolean value',
  year: (value) => !value || isInt(`${value}`, { min: 1900, max: new Date().getFullYear() }) || 'This field must be a valid year',
  month: (value) => !value || isInt(`${value}`, { min: 1, max: 12 }) || 'This field must be a valid month',
  day: (value) => !value || isInt(`${value}`, { min: 1, max: 31 }) || 'This field must be a valid day',
  nonNegativeInteger: (value) => !value || isInt(`${value}`, { min: 0 }) || 'This field must be an integer greater than or equal to 0',
  positiveInteger: (value) => !value || isInt(`${value}`, { min: 1 }) || 'This field must be a positive integer',
  nonNegativeFloat: (value) => !value || isFloat(`${value}`, { min: 0 }) || 'This field must be a number greater than or equal to 0',
  percentage: (value) => !value || isFloat(`${value}`, { min: 0, max: 100 }) || 'This field must be a percentage between 0 and 100',
  date: (value) => {
    return !value || moment(value).isValid() || 'This field must be a valid date and time';
  },
  dateTime: (value) => {
    return !value || moment(value).isValid() || 'This field must be a valid date and time';
  },
  uuid: (value) => !value || isUUID(value, 4) || 'This field must be a valid UUID',
  chineseOnly: (value) => !value || /^[\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff\s]+$/.test(value) || 'Only Chinese characters are allowed',
  englishOnly: (value) => /^[a-zA-Z\s\-'.]+$/.test(value) || 'Only English letters are allowed',
};

export const fields = {
  id: {
    name: 'id',
    type: 'hidden',
    readOnly: true,
  },
  status: {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: [
      { value: 'Enabled', label: 'Enabled' },
      { value: 'Disabled', label: 'Disabled' },
    ],
  },
  nameEng: {
    name: 'nameEng',
    label: 'Name (English)',
    type: 'text',
  },
  nameChi: {
    name: 'nameChi',
    label: 'Name (Chinese)',
    type: 'text',
  },
  accountCode: {
    name: 'accountCode',
    label: 'Account Code',
    type: 'text',
  },
  remarks: {
    name: 'remarks',
    label: 'Remarks',
    type: 'text',
    multiline: true,
  },
  ordering: {
    name: 'ordering',
    label: 'Ordering',
    type: 'number',
    step: '1',
  },
  amount: {
    name: 'amount',
    label: 'Amount',
    type: 'number',
    step: '0.01',
    startAdornment: <InputAdornment position="start">HKD</InputAdornment>,
  },
};

export default {
  validationRules,
  fields,
};
